import { Stack } from "@mantine/core";
import BodyHeader from "./BodyHeader";
import CardAttributes from "./CardAttributes";
import { DiscoveryEvidenceBodyByKind } from "../../../explore/discovery-evidence/DiscoveryEvidenceBodyByKind";
import { getDiscoveryEvidenceBodyKind } from "../../../explore/discovery-evidence/discoveryEvidenceBodyKind";

const CardBody = ({
  item,
  loadEvidence: propLoadEvidence,
  isLoadingMl = false
}: {
  item: any;
  loadEvidence?: () => void;
  isLoadingMl?: boolean;
}) => {
  const bodyKind = getDiscoveryEvidenceBodyKind(item);

  return (
    <Stack>
      <BodyHeader item={item} />
      <CardAttributes item={item} loadEvidence={propLoadEvidence} />
      <DiscoveryEvidenceBodyByKind
        kind={bodyKind}
        item={item}
        isLoadingMl={isLoadingMl}
      />
    </Stack>
  );
};

export default CardBody;
